export default "/static/fa8dc503c2037811.svg"